// eslint-disable-next-line no-restricted-imports
import {type i18n, type TFunction} from 'i18next'
import {type TranslationArrayKeys, type TranslationKeys, type TranslationOptions} from '@colonist/i18n'

export class ColonistI18n {
    private readonly i18n: i18n

    constructor(i18next: i18n) {
        this.i18n = i18next
    }

    t(key: TranslationKeys, options?: TranslationOptions): string {
        const invalidTranslation = 'Invalid Translation'
        try {
            const translation = this.i18n.t(key, options)
            return typeof translation == 'string' ? translation : invalidTranslation
        } catch(e) {
            return invalidTranslation
        }
    }

    tArray<T = string[]>(key: TranslationArrayKeys, options?: TranslationOptions): T {
        const invalidTranslation = ['Invalid Translation'] as T
        try {
            const allOptions = ColonistI18n.addReturnObjectOption(options)
            const translation = this.i18n.t(key, allOptions)
            if(Array.isArray(translation)) return translation as T
            return invalidTranslation
        } catch(e) {
            return invalidTranslation
        }
    }

    private static addReturnObjectOption(options?: TranslationOptions): TranslationOptions {
        return options == undefined ? {returnObjects: true} : {
            ...options,
            returnObjects: true,
        }
    }
}

export namespace I18n {
    export const defaultLanguage = 'en'
    export const languages = ['en', 'af', 'ar', 'ca', 'cs', 'da', 'de', 'el', 'es', 'fi', 'fr', 'he', 'hi', 'hu', 'it', 'ja', 'ko', 'nl', 'no', 'pl', 'pt-BR', 'pt-PT', 'ro', 'ru', 'sr', 'sv', 'th', 'tr', 'uk', 'vi', 'zh-CN', 'zh-TW']

    export const languageEnglishNames: {[key: string]: string | undefined} = {
        /* eslint-disable @typescript-eslint/naming-convention */
        en: 'English',
        af: 'Afrikaans',
        ar: 'Arabic',
        ca: 'Catalan',
        cs: 'Czech',
        da: 'Danish',
        de: 'German',
        el: 'Greek',
        es: 'Spanish',
        fi: 'Finnish',
        fr: 'French',
        he: 'Hebrew',
        hi: 'Hindi',
        hu: 'Hungarian',
        it: 'Italian',
        ja: 'Japanese',
        ko: 'Korean',
        nl: 'Dutch',
        no: 'Norwegian',
        pl: 'Polish',
        'pt-BR': 'Brazilian Portuguese',
        'pt-PT': 'European Portuguese',
        ro: 'Romanian',
        ru: 'Russian',
        sr: 'Serbian',
        sv: 'Swedish',
        th: 'Thai',
        tr: 'Turkish',
        uk: 'Ukrainian',
        vi: 'Vietnamese',
        'zh-CN': 'Chinese (China Mainland)',
        'zh-TW': 'Chinese (Taiwan)',
        /* eslint-enable @typescript-eslint/naming-convention */
    }
}

export type TranslationFunction = TFunction
